module.exports = __webpack_public_path__ + "static/media/home-road-pickup-short-xlarge_2x.e06a4f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-road-pickup-short-xlarge_2x.png
// module id = 1530
// module chunks = 27